import { useEffect, useRef, useState } from 'react';
import Page from '../..';
export function PageBannerLayouts() {
  const ref = useRef<HTMLCanvasElement>(null);
  const [secondaryFontLoaded, setSecondaryFontLoaded] = useState(false);

  useEffect(() => {
    const secondaryFont = new FontFace('Secondary', 'url(/Secondary.ttf)');
    secondaryFont.load().then(() => {
      document.fonts.add(secondaryFont);
      setSecondaryFontLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (ref.current && secondaryFontLoaded) {
      const canvas = ref.current;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.fillStyle = '#2D65F3';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = 'white';
        ctx.font = 'italic 150px Secondary';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.shadowColor = 'rgba(0,0,0,1)';
        ctx.shadowOffsetX = -7;
        ctx.shadowOffsetY = 5;
        ctx.shadowBlur = 4;
        (ctx as any).letterSpacing = '3px';
        ctx.fillText('OFERTA', canvas.width / 2, 10);
        ctx.fillStyle = '#FBEF3D';
        const margin = 30;
        const top = 170;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.shadowBlur = 4;
        ctx.beginPath();
        ctx.roundRect(
          margin,
          top,
          canvas.width - 2 * margin,
          canvas.height - top - margin,
          [12],
        );
        ctx.fill();
      }
    }
  }, [secondaryFontLoaded]);

  const downloadImage = () => {
    if (ref.current) {
      const canvas = ref.current;
      const image = canvas
        .toDataURL('image/png')
        .replace('image/png', 'image/octet-stream');
      const link = document.createElement('a');
      link.download = 'banner.png';
      link.href = image;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const width = 210 * 2.83465;

  return (
    <Page className="page-banner">
      <div style={{ margin: 'auto' }}>
        <canvas ref={ref} width={width} height={width * 1.4142857142857144} />
        <button onClick={downloadImage}>Baixar Imagem</button>
      </div>
    </Page>
  );
}
